export default "__VITE_ASSET__2703d39b__"